import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useApi } from "@platform/api";

import type { ConsultingBroker } from "./types";

export function useConsultingBroker(
  brokerId?: string,
): UseQueryResult<ConsultingBroker> {
  const axiosInstance = useApi();

  return useQuery<ConsultingBroker>({
    queryKey: ["consulting", "broker", brokerId ?? null],
    queryFn: () =>
      axiosInstance
        .get<ConsultingBroker>(`/consulting/v1/brokers/${brokerId}`)
        .then((response) => response.data),
    enabled: Boolean(brokerId),
  });
}
